import React from "react";
import { Input, Checkbox, NumericInput } from "@abb/abb-common-ux-react";
import "./testplan.sass";
import { ITestPlanInstrument } from "../../models/testplan/TestplanInstrument";
import { IKeyedInProperty } from "../../models/testplan/TestplanKeyedIn";
import { TestPlanScreen } from "../../utilities/Screen";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";

interface IInputPositionProperties {
  screenKey: TestPlanScreen;
  isCreate?: boolean;
  isShowFixed: boolean;
  isStripLength: boolean;
  isClone: boolean;
  index: number;
  keyedInPropertyState?: IKeyedInProperty;
  instrumentState?: ITestPlanInstrument;
  inputStripLength?: (val: string, index: number) => void;
  inputNumberOfPosition?: (val: number | string, index: number) => void;
  inputFixedPosition?: (val: string, index: number) => void;
  isFixedPositionHandler?: (val: any, index: number) => void;
}

export default class InputPosition extends React.Component<IInputPositionProperties> {
  public render() {
    return (
      <Translation>
                {
                    t =>
      <div className="actions">
        <div className="row justify-content-center align-items-center">

          {this.props.isClone ? (
            <div className="col-md-3 col-sm-3">
              <div className="form-row">
                <label className="position-font mt-2">
                  {t(CONSTANTS.CLONE_FROM)}
                </label>
                <select style={{ width: "120px" }}
                  className="form-control col-sm-4"
                  id="sel1" />
              </div>
            </div>
          ) : null}

          {this.props.isStripLength ? (
            <div>
              <div className="form-row">
              {this.props.isCreate ?
                <div style={{visibility: "hidden", height:0}}>
                  <label className="position-font mt-2" >
                    {t(CONSTANTS.SAMPLE_STRIP_LENGTH)}:{" "}
                  </label>
                  <Input
                    dataType="number"
                    disabled={this.props.isCreate ? false : true}
                    // tslint:disable-next-line: jsx-no-lambda
                    onValueChange={(value: string) => this.props.inputStripLength(value, this.props.index)}
                    type="normal"
                    className={this.props.isCreate ? "w-50 ml-2" : "disable-input col-sm-2"}
                    value={String(this.props.instrumentState.stripLength)} />
                </div> :
                <div>
                    <label className="position-font mt-2">
                      {t(CONSTANTS.SAMPLE_STRIP_LENGTH)}:{" "}
                      <label className="input-default-font mt-1 ml-2">{this.props.instrumentState.stripLength.toLocaleString()} mm</label>
                    </label>
                </div>
                }
              </div>
            </div>
          ) : null}
          <div className="ml-5" >
            <div className="form-row">
              <label className="position-font mt-2">
                {" "}
                {t(CONSTANTS.NO_OF_POSITION)}:
              </label>
              {this.props.isCreate ?
                <NumericInput
                    type="normal"
                    className={this.props.isCreate ? "w-50 ml-2" : "disable-input w-50"}
                    value={this.props.screenKey === TestPlanScreen.Instrument ?
                      (this.props.instrumentState.partitionsCount)
                      : (this.props.keyedInPropertyState.partitionsCount)}
                    min={1}
                    max={999}
                    step={1}
                    disableEdit={false}
                    disabled={this.props.isCreate ? false : true}
                    onChange={(value: number) => this.props.inputNumberOfPosition(value, this.props.index)}
                  />:
                <label className="input-default-font mt-1 ml-2">
                  {this.props.screenKey === TestPlanScreen.Instrument ? this.props.instrumentState.partitionsCount
                    : this.props.keyedInPropertyState.partitionsCount}
                </label>
              }
            </div>
          </div>

          {this.props.isShowFixed ? (
            <div className="col-md-3 col-sm-3" >
              <div className="row">
                <Checkbox
                  label={t(CONSTANTS.FIXED_POSITION_WIDTH)}
                  sizeClass="small"
                  className="position-font"
                  // tslint:disable-next-line: jsx-no-lambda
                  onChange={(value) => this.props.isFixedPositionHandler(value, this.props.index)}
                  value={this.props.instrumentState.isFixedPosition}
                />
                {this.props.instrumentState.isFixedPosition ? (
                  <Input
                    dataType="number"
                    // tslint:disable-next-line: jsx-no-lambda
                    onValueChange={(value: string) => this.props.inputFixedPosition(value, this.props.index)}
                    type="normal"
                    className="col-sm-3"
                    value={String(this.props.instrumentState.fixedPositionWidth)}
                  />
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </div>
  }
  </Translation>
    );
  }
}
